import { AxiosError } from "axios";
import { alert, alertLoading, alertRedirect } from "../@core/components/alert";
import { formatErrorIsObject, getUserData, getFrontParam } from "./Utils";
import Swal from "sweetalert2";
import { getRequest } from "../services/api";
import { websocketService } from "../services/websocket";

export const ErrorHandling = (error: AxiosError, navigate?) => {
  console.log("esse");
  console.log(error);
  const user = getUserData();
  if (error.message === "timeout" || error.code == "ECONNABORTED") {
    alert(
      "Tempo de carregamento excedido. Por favor, verifique sua conexão com a internet ou atualize a pagina novamente. Caso o erro persista entre em contato com o administrador",
      "error"
    );
    return "";
  }

  if (error.response?.status === 0 || error.code == "ERR_NETWORK") {
    localStorage.removeItem("@revalida.user");
    localStorage.removeItem("@revalida.token");

    // Desconectar WebSocket
    websocketService.disconnect();
    window.dispatchEvent(new Event('logout'));

    if (navigate) {
      navigate("/login");
      alert("Sessão expirada, por favor login novamente", "info");
      return;
    }
    window.location.href = "/login";

    alert(
      "Ops! Não foi possível concluir a operação. Parece que há um problema com a sua conexão à internet. Verifique sua conexão e tente novamente. Se o problema persistir, entre em contato com o suporte técnico para assistência.",
      "info"
    );
    return "";
  }

  if (error.response?.status === 404) {
    if (error.response.data == "usuario não encontrado") {
      localStorage.removeItem("@revalida.user");
      localStorage.removeItem("@revalida.token");

      // Desconectar WebSocket
      websocketService.disconnect();
      window.dispatchEvent(new Event('logout'));

      alertRedirect(
        "Usuário não encontrado, redirecionado para login",
        "error",
        "/login"
      );
      return "";
    }
  }

  if (error.response?.status === 401) {
    if (error.response.data == "Acesso não autorizado") {
      localStorage.removeItem("@revalida.user");
      localStorage.removeItem("@revalida.token");

      // Desconectar WebSocket
      websocketService.disconnect();
      window.dispatchEvent(new Event('logout'));

      alertRedirect(
        "Sua sessão expirou ou foi identificado acesso simultâneo na sua conta. Você será redirecionado para o login.",
        "info",
        "/login"
      );
      return "";
    }

    if (error.response.data == "Em manutenção") {
      localStorage.removeItem("@revalida.user");
      localStorage.removeItem("@revalida.token");

      // Desconectar WebSocket
      websocketService.disconnect();
      window.dispatchEvent(new Event('logout'));

      window.location.href = "/manutencao";
      return "";
    }

    if (error.response.data == "Acesso negado! Você foi bloqueado no sistema") {
      localStorage.removeItem("@revalida.user");
      localStorage.removeItem("@revalida.token");

      // Desconectar WebSocket
      websocketService.disconnect();
      window.dispatchEvent(new Event('logout'));

      alertRedirect(
        "Acesso negado! Você foi bloqueado no sistema. Você será redirecionado para o login.",
        "info",
        "/login"
      );
      return "";
    }
  }

  if (
    error.response?.status === 500 &&
    error.response?.data == "Your email address is not verified."
  ) {
    Swal.fire({
      text: "Desculpe! Vimos que seu email não foi verificado. Por favor clique em reenviar email de verificação",
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Reenviar email de verificação",
    }).then((result) => {
      if (result.isConfirmed) {
        alertLoading("Enviando email...", "info");
        const frontParam = getFrontParam();
        const url = frontParam
          ? `mail/resend/${user.id}?front=${frontParam}`
          : `mail/resend/${user.id}`;
        getRequest(url).then((response) => {
          alertRedirect(
            "Email enviado com Sucesso. Em instante você sera redirecionado para tela de login",
            "success",
            "/login"
          );
        });
      }
    });
    return;
  }

  if (error?.response?.status == 403) {
    const data: any = error?.response?.data;
    if (error?.response?.data == "ACCESS_DENIED") {
      alert(
        "Este acesso está disponível apenas para quem adquiriu o plano correspondente.",
        "info"
      );
      const pathname = location.pathname.split("/");
      navigate(`/${pathname[1]}/home`);
      return;
    }

    if (data?.status == "NO_PLAN_IN_FORCE") {
      localStorage.removeItem("@revalida.user");
      localStorage.removeItem("@revalida.token");
      localStorage.setItem("@revalida.student", JSON.stringify(data.student));

      // Desconectar WebSocket
      websocketService.disconnect();
      window.dispatchEvent(new Event('logout'));
      Swal.fire({
        text: "Você não possui nenhum plano ativo no momento. Clique no botão 'Adquirir plano' e confira as nossas ofertas.",
        icon: "info",
        showDenyButton: true,
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonText: "Adquirir plano",
        denyButtonText: `Fechar`,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/adquirir-plano");
        } else if (result.isDenied) {
          localStorage.removeItem("@revalida.student");
        }
      });
      navigate(`/login`);
      return;
    }
  }

  if (typeof error?.response?.data == "object") {
    if (error?.response?.status == 422) {
      alert(
        formatErrorIsObject(error?.response?.data) ?? "Algo deu errado",
        "error",
        error?.response?.status
      );
    } else {
      alert(JSON.stringify(error?.response?.data), "error", error.status);
    }
    return "";
  } else {
    if ((error.response?.data as any)?.includes("error_messages")) {
      alert(
        "Não foi possível efetuar o cadastro, pois o pagseguro está com instabilidade no momento. Tente novamente mais tarde, caso persista entre em contato com o administrador",
        "error"
      );
      return "";
    }

    alert(
      error?.response?.data == "" || error?.response?.data == undefined
        ? JSON.stringify(error)
        : error?.response?.data,
      "error",
      error?.response?.status
    );
    return "";
  }
};
